import Routes from './SelectMFARoutes.container';
export { default as Component } from './SelectMFARoutes.component';

export default Routes;
